import { Component, Input, OnInit } from '@angular/core';
import {
  ChargerTypeConst,
  ConsumerModel,
  ConsumerP14aModuleDisplayNames
} from '@bo-client/activation-management/grid-registration/model/consumer.model';
import { GridRegistrationTypeEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { MetaService } from '@bo-client/core/api/meta-service';

/**
 * Zusammenfassung der Verbrauchseinrichtungen einer Netzanmeldung.
 *
 * Die angezeigten Felder richten sich nach der **Vorgangsart** — demselben Schlüssel, mit dem
 * `GridRegistrationFormConsumerComponent` seine Feldgruppen wählt. Die Beschriftungen sind wörtlich
 * aus dem jeweiligen Formular übernommen, damit Zusammenfassung und Eingabe zusammenpassen.
 *
 * Jede Angabe steht in einem eigenen `div` und hat ein `*ngIf` auf den Modellwert:
 * `app-value-with-label` setzt selbst keinen Umbruch, und Alt-Datensätze haben viele der Felder nie
 * gefüllt.
 *
 * Nicht zuständig für den Speicher des **neuen** Speicherprozesses (v2) — dessen Lade- und
 * Wechselrichterleistung stellt `app-storage-v2-technical-summary` gemeinsam mit den
 * Wechselrichtern dar.
 */
@Component({
  selector: 'app-consumers-summary',
  templateUrl: './consumers-summary.component.html',
  styleUrls: ['./consumers-summary.component.scss']
})
export class ConsumersSummaryComponent implements OnInit {
  @Input() consumers: ConsumerModel[];

  /**
   * Vorgangsart der Netzanmeldung. Fehlt sie, bleibt es bei den Ladeeinrichtungs-Feldern — damit
   * verhalten sich Aufrufer, die die Vorgangsart nicht durchgeben, wie bisher.
   */
  @Input() gridRegistrationType?: GridRegistrationTypeEnum;

  protected readonly p14aModuleDisplayNames = ConsumerP14aModuleDisplayNames;

  constructor(protected metaService: MetaService) {}

  ngOnInit(): void {}

  protected get showChargerFields(): boolean {
    return (
      this.gridRegistrationType == null || this.gridRegistrationType === GridRegistrationTypeEnum.Charger
    );
  }

  protected get showHeatPumpFields(): boolean {
    return this.gridRegistrationType === GridRegistrationTypeEnum.EHeating;
  }

  protected chargerTypeDisplayName(consumer: ConsumerModel): string | undefined {
    return consumer.chargerType ? ChargerTypeConst[consumer.chargerType]?.displayName : undefined;
  }

  /** Überschriften nur setzen, wenn der Abschnitt auch Werte hat. */
  protected hasMeterData(consumer: ConsumerModel): boolean {
    return !!consumer.meterNumber || !!consumer.maLo;
  }

  protected hasP14aData(consumer: ConsumerModel): boolean {
    return (
      !!consumer.rateLimitingType ||
      !!consumer.controllability ||
      !!consumer.meterOperator ||
      !!consumer.enwgP14aModule
    );
  }
}
